import { CalendarTranslation } from 'locales/de/pages/calendar';

const en: CalendarTranslation = {
  title: 'Calendar',
  settings: 'Settings',
  openFailed: 'Appointments failed to load',
  detail: {
    openFailed: 'Event could not be opened',
    notFound: 'Event could not be found'
  },
  type: {
    general: 'General',
    study: 'Studies',
    event: 'Event',
    legal: 'Legal',
    holiday: 'Holiday'
  },
  calendar_props: {
    date: 'Date',
    time: 'Time',
    event: 'Event',
    allDay: 'All Day',
    week: 'Week',
    day: 'Day',
    month: 'Month',
    previous: 'Back',
    next: 'Next',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    today: 'Today',
    agenda: 'Agenda',
    noEventsInRange: 'There are no events in this range.',
    showMore: 'more'
  }
};

export default en;
